export default __webpack_public_path__ + "static/media/26t.be425c52.jpg";